export default __webpack_public_path__ + "static/media/Abstract_black_4K.3ca9e6c9.mp4";